import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-[#0D172A] flex items-center justify-center z-50">
      <div className="relative w-32 h-32">
        <img
          src="/assets/images/car-loader.png" // Ensure the image is in public/assets/images
          alt="Loading Car"
          className="animate-spin-slow"
        />
      </div>
    </div>
  );
};

export default Loader;
